"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STORAGE_KEY = exports.HOVER_EXPAND_WAITING = exports.PLACEHOLDER_DOT_INDENTATION = exports.COLLAPSED_ICON_INDENTATION = void 0;
var COLLAPSED_ICON_INDENTATION = 24;
exports.COLLAPSED_ICON_INDENTATION = COLLAPSED_ICON_INDENTATION;
var PLACEHOLDER_DOT_INDENTATION = 3; // indent for placeholder dot
// Waiting time when hovering a collapsed parent before expanding

exports.PLACEHOLDER_DOT_INDENTATION = PLACEHOLDER_DOT_INDENTATION;
var HOVER_EXPAND_WAITING = 1000;
exports.HOVER_EXPAND_WAITING = HOVER_EXPAND_WAITING;
var STORAGE_KEY = 'nestedSortable';
exports.STORAGE_KEY = STORAGE_KEY;